module.exports = __webpack_public_path__ + "img/loading.b911aa1.svg";